module.exports = __webpack_public_path__ + "static/media/apple-podcast.73e95866.svg";